import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutUserDevicesGridExpansion extends Layout {
    sourceUserRecognizedDevice: DataSource;
    tableDevices: Table;
}
